import {
  Col,
  Row,
  Space,
  Form,
  Input,
  Radio,
  Table,
  Upload,
  UploadProps,
  Modal,
  message,
} from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect, useState } from 'react';
import { DownloadIcon, UploadIcon } from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import pageTitleStore from 'store/pageTitleStore';
import * as XLSX from 'xlsx';
import { IProduct } from 'interface/product.interface';
import { useHistory, useLocation } from 'react-router-dom';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { ColumnsType } from 'antd/es/table';
import { UploadFile } from 'antd/lib';
import ProductApi from 'apis/ProductApi';
import { STATUS } from 'constants/reponseStatus';
import { useUser } from 'contexts/User';
import { openNotificationWithIcon } from 'utils/notification';

export default function ProductUpdatePage(): JSX.Element {
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const { user, signOut } = useUser();
  const history = useHistory();
  useEffect(() => {
    setTitle('Cập nhật thông tin sản phẩm');
    setBreadcrumb([
      {
        title: <a href="/product">Sản phẩm</a>,
      },
      { title: <a>Cập nhật thông tin sản phẩm</a> },
    ]);
  }, []);
  const location = useLocation<{ selectedProducts: IProduct[] }>();
  const [products, setProducts] = useState<IProduct[]>(
    location?.state.selectedProducts || []
  );

  const [dataExcel, SetDataExcel] = useState<any[]>();
  // Object.values(location.state || {})[0]

  const [modalSyncVisible, setModalSyncVisible] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [isUpdateLoading, setUpdateLoading] = useState(false);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const pagination = { page: page, page_size: page_size };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (record) => {
        const index = products.findIndex((item) => item.id === record) + 1;
        return index;
      },
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (image_default) => (
        <img style={{ height: 50 }} src={image_default} />
      ),
      width: 100,
    },
    {
      title: 'Mã basic (new)',
      dataIndex: 'basic_product',
      width: 177,
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'pro_tpl_code',
      width: 177,
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'product_code',
      width: 261,
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'product_name',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'prod_grp2_name',
    },
    {
      title: 'Dòng hàng SAP',
      dataIndex: 'line_sap',
      width: 148,
    },
    {
      title: 'Xman',
      dataIndex: 'xman',
      width: 200,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chungloai_text',
      width: 112,
    },
    {
      title: 'Giá vốn tồn tham khảo',
      dataIndex: 'cost_price',
      width: 185,
      align: 'end',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá bán',
      dataIndex: 'price',
      width: 135,
      align: 'end',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá vốn bình quân',
      dataIndex: 'phankhuc_kh_text',
      align: 'right',
      width: 157,
    },
    {
      title: 'Phân khúc giá',
      dataIndex: 'phankhuc_gia',
      width: 157,
    },
    {
      title: 'Loại đá',
      dataIndex: 'loai_da',
      width: 124,
    },
    {
      title: 'Nhóm đá',
      dataIndex: 'nhom_da',
      width: 124,
    },
    {
      title: 'Aging',
      dataIndex: 'aging',
      width: 157,
    },
    {
      title: 'BST',
      dataIndex: 'bst_text',
      width: 60,
    },
    {
      title: 'Mã bộ',
      dataIndex: 'zma_bo',
      width: 150,
    },
    {
      title: 'Mã cặp',
      dataIndex: 'zma_ts_cap',
      width: 150,
    },
    {
      title: 'Giới tính',
      dataIndex: 'gioitinh_text',
      width: 90,
    },
    {
      title: 'Material Type',
      dataIndex: 'product_type_code',
      width: 126,
    },
    {
      title: 'Tuổi vàng',
      dataIndex: 'purity_of_gold',
      width: 99,
    },
    {
      title: 'Màu sắc',
      dataIndex: 'mausac_text',
      width: 120,
    },
    {
      title: 'Size ổ hột',
      dataIndex: 'ohot_kc_text',
      width: 99,
    },
    {
      title: 'Xplant Status',
      dataIndex: 'xplant_status',
      width: 125,
    },
    {
      title: 'Phân nhóm',
      dataIndex: '',
      width: 204,
    },
    {
      title: 'Trạng thái mẫu',
      dataIndex: '',
      width: 135,
    },
    {
      title: 'Is_DMHHKN',
      dataIndex: '',
      width: 115,
    },
    {
      title: 'PLHH',
      dataIndex: '',
      width: 114,
    },
    {
      title: 'Material (Mẫu đại diện)',
      dataIndex: 'mau_dai_dien',
      width: 150,
      render: (record: any) => {
        return <>{record?.toString()}</>;
      },
    },
    {
      title: 'Material Group',
      dataIndex: '',
      width: 134,
    },
    {
      title: 'PL ni => Khung ni chuẩn (hàng mới)',
      dataIndex: 'item_size',
      width: 270,
    },
    {
      title: 'DGTQ',
      dataIndex: '',
      width: 73,
    },
    {
      title: 'PL tình trạng theo dõi NLSX',
      dataIndex: '',
      width: 219,
    },
    {
      title: 'Danh mục cũ',
      dataIndex: '',
      width: 121,
    },
    {
      title: 'Danh mục',
      dataIndex: '',
      width: 114,
    },
    {
      title: 'Basic status',
      dataIndex: 'basic_statust',
      width: 177,
    },
    {
      title: 'Trạng thái sản phẩm',
      width: 171,
      render: (product: IProduct) => (
        <span>
          {
            PRODUCT_POF_STATUS.find((item) => item.value === product.pof_status)
              ?.label
          }
        </span>
      ),
    },
    {
      title: 'Vòng đời giỏ hàng hiện tại',
      width: '200px',
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      align: 'center',
      dataIndex: 'doanhthu_6th',
      width: 100,
    },
    {
      title: 'Doanh thu TB 1 tháng (VND)',
      align: 'center',
      dataIndex: 'doanhthu_tb_1th',
      width: 200,
    },
    {
      title: 'Trạng thái bán hàng',
      width: 168,
      render: (product: IProduct) => (
        <span>
          {PRODUCT_STATUS.find((item) => item.value === product.status)?.label}
        </span>
      ),
    },
    {
      title: 'Tổng SL tồn hiện tại',
      align: 'right',
      dataIndex: 'tongsl_ton',
      width: 100,
    },
    {
      title: 'Tổng SL Tổng giá trị',
      align: 'right',
      dataIndex: 'tong_giatri',
      width: 100,
    },
    {
      fixed: 'right',
      width: 0,
      align: 'center',
    },
  ];

  // dataExcel.map((item, index) => {
  //   if (item.bom_info === null) {
  //     dataExcel[index].bom_info = ' ';
  //   }
  // });

  function generateExcel() {
    // const wb = XLSX.utils.book_new();
    // const ws = XLSX.utils.json_to_sheet(dataExcel);
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // XLSX.writeFile(wb, `danh_sách_sản_phẩm.xlsx`);

    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      return column.title;
    });
    data.push(headerRow);
    products.forEach((product) => {
      const rowData = columns.map((column) => {
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `danh_sach_san_pham.xlsx`);
  }

  const modalColumn: ColumnsType<any> = [
    {
      title: 'Mã sản phẩm',
      width: 177,
      render(record) {
        return <>{record?.data_update?.product_code}</>;
      },
    },
    {
      title: 'Trạng thái cập nhật',
      width: 177,
      render(record) {
        return <>Hoàn tất</>;
      },
    },
  ];

  const handleUpdate = () => {
    const updatedProducts = products.map((product) => ({
      ...product,
      updated_by: user?.email,
    }));
    setUpdateLoading(true);
    ProductApi.updateProductList(updatedProducts)
      .then((response) => {
        setUpdateLoading(false);
        if (response?.data.length != 0 && response?.data[0].error) {
          message.error(response?.data[0].error);
        } else {
          openNotificationWithIcon('success', 'Cập nhật thành công');
          history.goBack();
        }
      })
      .catch((error) => {
        setUpdateLoading(false);
        message.error(error?.response?.data.message[0]);
      });
  };

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });

              if (
                excelData.length == 0 ||
                excelData[0].length == 0 ||
                excelData[0][0] != 'STT'
              ) {
                openNotificationWithIcon(
                  'error',
                  'File không đúng mẫu, vui lòng tải mẫu'
                );
                return;
              }
              excelData = excelData.slice(1);

              const newProducts: IProduct[] = [];
              excelData.forEach((row) => {
                const product: any = {};

                for (let index = 0; index < row.length; index++) {
                  const value = row[index];

                  product[columns[index].dataIndex] =
                    value === '' || value === undefined
                      ? undefined
                      : columns[index].dataIndex == 'pro_tpl_code'
                      ? value.toString()
                      : value;
                }
                newProducts.push(product);
              });

              setProducts(newProducts);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  return (
    <MainLayout isLoading={isUpdateLoading}>
      <div className="flex justify-end mb-4">
        <Button onClick={() => handleUpdate()}>
          <UploadIcon />
          Cập nhật
        </Button>
      </div>

      <Content className="mb-4">
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          align="middle"
          className="mb-1"
        >
          <Col span={12}>
            <div className="text-xl font-bold">
              File cập nhật thông tin sản phẩm
            </div>
          </Col>
          <Col span={12}>
            <Row justify="end" align="middle">
              <Space>
                <div className="text-primary-70 text-base">
                  Tải danh sách sản phẩm tại đây
                </div>
                <Button
                  bgColor={'bg-white'}
                  border={'border-neutral-90'}
                  customClass={'no-show'}
                  onClick={generateExcel}
                >
                  <DownloadIcon />
                </Button>
              </Space>
            </Row>
          </Col>
        </Row>

        {/* <Modal
          title="Chi tiết cập nhật"
          open={modalSyncVisible}
          onCancel={() => {
            setModalSyncVisible(false);
          }}
          footer={null}
          width={'40%'}
        >
          <div className="my-4 pl-4">
            <p className="text-sm">
              Cập nhật thành công{' '}
              <span className="text-primary-50 font-bold">10/20</span>, cập nhật
              thất bại <span className="text-[#DC362E] font-bold">10/20</span>
            </p>
          </div>
          <Table
            className="customTable"
            columns={modalColumn}
            dataSource={modalContent}
          />

          <div className="flex mt-4 justify-center">
            <Button
              onClick={() => {
                setModalSyncVisible(false);
              }}
            >
              Đóng lại
            </Button>
          </div>
        </Modal> */}

        <Form layout="vertical" className="items-center" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {/* <Col className="" span={24}>
              <Form.Item name="plantCode">
                <Radio.Group>
                  <Radio value={1}>Cập nhật sản phẩm</Radio>
                  <Radio value={2}>Đổi mã mẫu</Radio>
                </Radio.Group>
              </Form.Item>
            </Col> */}
            <Col className="" span={24}>
              <Form.Item name="plantCode">
                <Space.Compact className="w-full mt-2">
                  <Input
                    style={{ width: 'calc(100% - 130px)', marginRight: '8px' }}
                    placeholder="Tải file định dạng .xls, .csv"
                    value={selectedFile?.name}
                  />
                  <Upload
                    accept=".xlsx,.xls,.csv"
                    onChange={handleUploadFile}
                    beforeUpload={() => false}
                    fileList={[]}
                    showUploadList={false}
                  >
                    <Button
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-primary-50'}
                      customClass="fix-border-radius"
                    >
                      Browser
                    </Button>
                  </Upload>
                </Space.Compact>
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content">
            <Table
              rowKey={(record) => record.id}
              columns={columns}
              className="customTable"
              dataSource={products}
              size="small"
              scroll={{ x: 958 }}
              // pagination={{
              //   className: 'flex items-center',
              //   current: page,
              //   pageSize: page_size,
              //   total: excelData?.length,
              //   showSizeChanger: true,
              //   pageSizeOptions: ['10', '20', '50'],
              // }}
            />
          </div>
        </Form>
      </Content>
    </MainLayout>
  );
}
